// extracted by mini-css-extract-plugin
module.exports = {"tabSelector":"tab-selector_tabSelector__2Zdmc"};